import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-xs-12 col-sm-10 col-md-8 col-lg-7 news__view-card" }
const _hoisted_2 = { class: "news__view-card-title s-pb-md row" }
const _hoisted_3 = { class: "news__view-card-date s-pb-md row" }
const _hoisted_4 = { class: "s-pb-md" }
const _hoisted_5 = { class: "news__view-card-description row s-pb-lg" }
const _hoisted_6 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_s_icon = _resolveComponent("s-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_skeleton, {
        class: _normalizeClass(["s-skeleton", `col-xs-5`]),
        type: "QBadge",
        animation: "fade"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_s_icon, {
        name: "app:date",
        color: "grey",
        size: "middle",
        class: "s-mr-sm"
      }),
      _createVNode(_component_q_skeleton, {
        class: "s-skeleton col-xs-5 col-sm-4 col-md-3",
        type: "text",
        animation: "fade"
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_q_skeleton, {
        class: "s-skeleton news__view-card-image",
        type: "QBadge",
        animation: "fade"
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.random([7, 11]), (n, index) => {
        return (_openBlock(), _createBlock(_component_q_skeleton, {
          key: index,
          class: _normalizeClass(["s-skeleton", `col-xs-${_ctx.random([7, 11])}`]),
          type: "text",
          animation: "fade"
        }, null, 8, ["class"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_q_skeleton, {
        class: _normalizeClass(["s-skeleton", `col-xs-5`]),
        type: "QBadge",
        animation: "fade"
      })
    ])
  ]))
}